import React from 'react'
import PPVTemplate from 'src/components/page/ppv'
import { commonCtaText, videoURI } from 'src/modules/utils/constants'

export default (props) => {
  return (
    <PPVTemplate
      lang="en"
      market="us"
      location={props.location}
      title="AEW Full Gear 2025"
      subtitle="Watch live this Saturday, Nov. 22, on Pay Per View with Fubo"
      video={videoURI + 'compressed/PPV_AEW_Full_Gear_16x9_3mb.mp4'}
      videoMobile={videoURI + 'mobile/PPV_AEW_Full_Gear_1x1_3mb.mp4'}
      ctaText={commonCtaText.getAccess}
      additionalFAQs={additionalFAQs}
      isEventEnded={true}
      heroFootnote="Fubo subscription not required"
    />
  )
}

const additionalFAQs = [
  {
    question: 'I bought AEW Full Gear 2025 on Fubo. How do I watch it?',
    answer:
      'If you ordered the AEW Full Gear 2025 Pay Per View event start by logging into fubo.tv. Go to the channel guide and find the Pay Per View channels, which are most likely at the top of the guide. Or, you can type “pay per view” in the search bar.',
  },
  {
    question:
      'Can I watch the AEW World Championship wrestling match with Hangman Adam Page and Samoa Joe in the AEW Full Gear 2025 Pay Per View event with Fubo?',
    answer:
      'Yes, AEW Full Gear 2025 Pay Per View event is available for purchase from Fubo. The entire event will be shown, including the AEW World Champion match, the AEW Women’s World Championship match, AEW World Tag Team Championship match, and more.',
  },
  {
    question: 'What time does AEW Full Gear 2025 start?',
    answer:
      'The event starts at 7pm ET, but the preshow coverage will start before that. Note that the preshow coverage may be on a different Pay Per View channel than the event coverage.',
  },
]
